export const createLabelWithFacetCount = (facetData, currentOption, selectedPrice = -1, useMonthly = false)=>{
    const { label , value  } = currentOption;
    const valueAsKey = useMonthly ? value * 100 : value;
    const isNotCurrentValue = facetData[valueAsKey] !== undefined && selectedPrice !== value;
    return `${label} ${isNotCurrentValue ? `(${facetData[valueAsKey].toLocaleString()})` : ""}`;
};
